import {
  ClientOffboardingNotifyContactsAdminGrid,
  type ClientOffboardingNotifyContactsAdminApi
} from '@jarvis/platform-ui';
import { useMemo } from 'react';
import {
  createClientOffboardingNotifyContact,
  deleteClientOffboardingNotifyContact,
  listClientOffboardingNotifyContacts,
  updateClientOffboardingNotifyContact
} from '../../../api/clientOffboardingNotifyContacts';

export function ClientOffboardingNotifyContactsAdminPage() {
  const api = useMemo<ClientOffboardingNotifyContactsAdminApi>(
    () => ({
      list: listClientOffboardingNotifyContacts,
      create: createClientOffboardingNotifyContact,
      update: updateClientOffboardingNotifyContact,
      delete: deleteClientOffboardingNotifyContact
    }),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <ClientOffboardingNotifyContactsAdminGrid
          api={api}
          stateStorageKey="webopsui:client-offboarding-notify-contacts-grid"
        />
      </div>
    </div>
  );
}
